module.exports = __webpack_public_path__ + "static/Calibre-Regular-5e227070115544834596a3c44575cf81.ttf";